var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useRef, useState } from "react";
import { useTheme } from "@emotion/react";
import * as Styled from "./dashboard.style";
import { ApplicationSpeedBox } from "./boxes/application-speed/application-speed-box";
import { LiftingPerformanceBox } from "./boxes/lifting-performance-box";
import { AirConsumptionBox } from "./boxes/air-consumption-box";
import { GraphPanel } from "ui/components/panels/graphs";
import { graphPanelWidth } from "ui/components/panels/graphs/graph.style";
import { simpleBoxHeight } from "ui/components/panels/dashboard/boxes/simple-box.style";
import { selectors, useAppSelector } from "store";
import { dashboardOpenHeight, useDashboardScale } from "hooks/dashboard-scale";
import { useGraphDataContext } from "providers/graph-panel";
import { PopoutWindow, useFitToWindowScale, } from "ui/components/elements/popout-window/popout-window";
var DashboardContent = function () { return (_jsxs(_Fragment, { children: [_jsx(GraphPanel, {}), _jsx(AirConsumptionBox, {}), _jsx(ApplicationSpeedBox, {}), _jsx(LiftingPerformanceBox, {})] })); };
var DockedDashboard = function () {
    var contentRef = useRef(null);
    var isGraphPanelOpen = useAppSelector(selectors.selectIsGraphPanelOpen);
    var graphPanelWindow = useGraphDataContext().graphPanelWindow;
    // A popped-out panel takes no room in the dashboard.
    var isGraphPanelDocked = isGraphPanelOpen && !graphPanelWindow;
    var scale = useDashboardScale(contentRef, isGraphPanelDocked);
    return (_jsx(Styled.Content, { ref: contentRef, scale: scale, isGraphPanelOpen: isGraphPanelDocked, children: _jsx(DashboardContent, {}) }));
};
/**
 * The dashboard in its own window, scaled to fit it: the box row alone while
 * the charts are closed, or with the graph panel above it while they are open.
 */
var PopoutDashboard = function (_a) {
    var targetWindow = _a.targetWindow;
    var theme = useTheme();
    var isGraphPanelOpen = useAppSelector(selectors.selectIsGraphPanelOpen);
    // The box row's natural height (the air consumption box keeps a row for the
    // energy usage box above it); the graph panel sits outside it, above. It is
    // measured once the popout has mounted the row (see PopoutWindow).
    var _b = __read(useState(simpleBoxHeight), 2), rowHeight = _b[0], setRowHeight = _b[1];
    var measureRow = useCallback(function (element) {
        if (element)
            setRowHeight(element.offsetHeight);
    }, []);
    var scale = useFitToWindowScale(targetWindow, graphPanelWidth(theme), isGraphPanelOpen ? dashboardOpenHeight : rowHeight);
    return (_jsx(PopoutWindow, { targetWindow: targetWindow, children: _jsx(Styled.PopoutContent, { ref: measureRow, scale: scale, children: _jsx(DashboardContent, {}) }) }));
};
export var DashboardPanel = function () {
    var dashboardWindow = useGraphDataContext().dashboardWindow;
    return (_jsx(Styled.DashboardPanel, { children: dashboardWindow ? (_jsx(PopoutDashboard, { targetWindow: dashboardWindow })) : (_jsx(DockedDashboard, {})) }));
};
